import { normalizeApiOrigin } from "@the-drop/customer-shared/api/url-builders";

/**
 * Base URL for API (no trailing slash). When unset, returns `""` so fetches use same-origin paths like
 * `/api/v1/...` — in Vite dev, `server.proxy` forwards `/api` (and `/socket.io`) to the API without CORS.
 * Set **`VITE_API_BASE_URL`** only when the browser must call the API host directly (then ensure **`CORS_ORIGINS`**
 * on the API includes this app's origin).
 */
export function getCustomerApiBaseUrl(): string {
  const v = import.meta.env.VITE_API_BASE_URL;
  if (typeof v === "string" && v.trim().length > 0) {
    return normalizeApiOrigin(v);
  }
  return "";
}

export {
  dispensaryMenuUrl,
  publicDispensaryCatalogUrl,
  complianceDeliveryZipUrl,
  complianceDeliveryAddressUrl,
} from "@the-drop/customer-shared/api/url-builders";
